import { HttpResponse } from 'msw';

import { handleDhcpLegacy } from './legacy/dhcp';
import { handleIgnitionLegacy } from './legacy/ignition';
import {
  handlePoeLegacy,
  handleInterfaceLegacy,
  handleWebserverLegacy,
} from './legacy/interface-webserver-poe';
import { handleLldpLegacy } from './legacy/lldp';
import { handleLogLegacy } from './legacy/log';
import {
  handleMqttLegacy,
  handleStaticMcLegacy,
  handleMulticastLegacy,
} from './legacy/mqtt-multicast-staticmc';
import { handleNtpLegacy } from './legacy/ntp';
import { handleQosLegacy, handleMirroringLegacy } from './legacy/qos-mirroring';
import {
  handleNatLegacy,
  handleSnmpLegacy,
  handleTrapLegacy,
} from './legacy/snmp-trap-nat';
import { handleStpLegacy } from './legacy/stp';
import { handleSystemLegacy } from './legacy/system';
import { handleUsbApiLegacy } from './legacy/usbapi';
import { handleUserLegacy } from './legacy/user';
import { handleVlanLegacy } from './legacy/vlan';

type LegacyBody = {
  service?: string;
  access?: string;
  command?: string;
  parameters?: unknown;
};

/**
 * Legacy POST /api: route by `service` → per-service handler uses `access` + `command`.
 */
export function handleLegacyPostApi(
  body: LegacyBody,
  userFromCookie: string | null,
): ReturnType<typeof HttpResponse.json> {
  const service = body.service ?? '';
  const command = body.command ?? '';

  switch (service) {
    case 'user':
      return handleUserLegacy(body, userFromCookie);
    case 'system':
      return handleSystemLegacy(body);
    case 'interface':
      return handleInterfaceLegacy(body);
    case 'ignition':
      return handleIgnitionLegacy(body);
    case 'log':
      return handleLogLegacy(body);
    case 'lldp':
      return handleLldpLegacy(body);
    case 'ntp':
      return handleNtpLegacy(body);
    case 'stp':
      return handleStpLegacy(body);
    case 'usbapi':
      return handleUsbApiLegacy(body);
    case 'webserver':
      return handleWebserverLegacy(body);
    case 'poe':
      return handlePoeLegacy(body);
    case 'vlan':
      return handleVlanLegacy(body);
    case 'qos':
      return handleQosLegacy(body);
    case 'mirroring':
      return handleMirroringLegacy(body);
    case 'dhcp':
      return handleDhcpLegacy(body);
    case 'snmp':
      return handleSnmpLegacy(body);
    case 'trap':
      return handleTrapLegacy(body);
    case 'nat':
      return handleNatLegacy(body);
    case 'mqtt':
      return handleMqttLegacy(body);
    case 'multicast':
      return handleMulticastLegacy(body);
    case 'staticmc':
      return handleStaticMcLegacy(body);
    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for ${service}:${command}`,
        },
        { status: 400 },
      );
  }
}
